import { CircleButton } from 'component/Button/CircleButton'
import css from 'component/Carousel/co/Navigation.module.scss'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'

type Props<T> = {
  store: CarouselStore<T>
}

export const Navigation = observer(<T, >(props: Props<T>) => {
  const { store } = props
  const { index, items } = store
  const first = index <= 0
  const last = index >= items.length - 1

  const onLeft = useLatestCallback(() => {
    --store.index
  })

  const onRight = useLatestCallback(() => {
    ++store.index
  })

  return <>
    <CircleButton className={css.left} size={32} action={onLeft} disabled={first}>
      <Icon size={16} name="arrow_left_alt" />
    </CircleButton>
    <CircleButton className={css.right} size={32} action={onRight} disabled={last}>
      <Icon size={16} name="arrow_right_alt" />
    </CircleButton>
  </>
})
